import { render } from "./ProductZoomer.vue?vue&type=template&id=31272d3a&scoped=true"
import script from "./ProductZoomer.vue?vue&type=script&lang=js"
export * from "./ProductZoomer.vue?vue&type=script&lang=js"

import "./ProductZoomer.vue?vue&type=style&index=0&id=31272d3a&lang=css"
import "./ProductZoomer.vue?vue&type=style&index=1&id=31272d3a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31272d3a"]])

export default __exports__